import { LandingLayout } from 'layouts';
import { useLocation, useNavigate } from 'react-router';
import { useLogout } from 'common/services/hooks';
import { Consents } from 'features/consents';
import { Footer, Header } from 'features/onboarding';

export type ConsentsLocationState = {
  originalState?: unknown;
  referrer?: string;
};

const PageConsents = () => {
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const state: ConsentsLocationState | undefined = location.state;
  const navigate = useNavigate();
  const onLogout = useLogout();

  const onAccept = async () => {
    await navigate(state?.referrer ?? '/', { replace: true, state: state?.originalState });
  };

  return (
    <LandingLayout
      contentRight={<Consents onAccept={onAccept} onReject={async () => onLogout()} />}
      footer={<Footer />}
      header={<Header items={[]} />}
    />
  );
};

export default PageConsents;
